import { TASKDETAIL_MODAL_TOGGLE } from "../actions/actions.types"

const INITIAL_STATE = {
    modal: {
        status: false,
        data: null
    }
}

const taskDetailReducer = (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case TASKDETAIL_MODAL_TOGGLE: 
            return {
                ...state,
                modal: {
                    status: !state.modal.status,
                    data: action.payload
                }
            }

        default:
            return state;
    }
}

export default taskDetailReducer;